<template>
    <div :class="[prefixCls]">
        <div
            :class="classes"
            @click="handleClick"
            @drop.prevent="onDrop"
            @paste="handlePaste"
            @dragover.prevent="dragOver = true"
            @dragleave.prevent="dragOver = false">
            <input
                ref="input"
                type="file"
                :class="[prefixCls + '-input']"
                @change="handleChange"
                :multiple="multiple"
                :accept="accept">
            <slot></slot>
        </div>
        <slot name="tip"></slot>
        <upload-list
            v-if="showUploadList"
            :files="fileList"
            :showRwmoveBtn="showRwmoveBtn"
            @on-file-remove="handleRemove"
            @on-file-preview="handlePreview"></upload-list>
    </div>
</template>
<script>
/*
accept: 
0	gif	image/gif
1	jpg	image/jpeg
2	png	image/png
3	bmp	image/bmp
4	psd	application/octet-stream
5	ico	image/x-icon
6	rar	application/octet-stream
7	zip	application/zip
8	7z	application/octet-stream
9	exe	application/octet-stream
10	avi	video/avi
11	rmvb	application/vnd.rn-realmedia-vbr
12	3gp	application/octet-stream
13	flv	application/octet-stream
14	mp3	audio/mpeg
15	wav	audio/wav
16	krc	application/octet-stream
17	lrc	application/octet-stream
18	txt	text/plain
19	doc	application/msword
20	xls	application/vnd.ms-excel
21	ppt	application/vnd.ms-powerpoint
22	pdf	application/pdf
23	chm	application/octet-stream
24	mdb	application/msaccess
25	sql	application/octet-stream
26	con	application/octet-stream
27	log	text/plain
28	dat	application/octet-stream
29	ini	application/octet-stream
30	php	application/octet-stream
31	html	text/html
32	htm	text/html
33	ttf	application/octet-stream
34	fon	application/octet-stream
35	js	application/x-javascript
36	xml	text/xml
37	dll	application/octet-stream
38	dll	application/octet-stream
1、如果要随表单提交，需配置 notAutoUpload base64
2、如果是导入 需要配置 isImport
使用方式 v-model 双向绑定
<ihlp-Upload multiple notAutoUpload base64 
    v-model="testUpload" max-size="100" 
    action="excelFileController/groupImportExcel" 
    :sc="'permission'">
	<Button type="ghost">{{$t('浏览')}}</Button>
</ihlp-Upload>
*/

    import UploadList from './upload-list.vue';
    // import ajax from './ajax';
    import { oneOf } from '@/utils/assist.js';
    import Emitter from './emitter.js';
    import { Dialog } from 'vant';
    const prefixCls = 'ivu-upload';

    export default {
        name: 'Upload',
        mixins: [ Emitter ],
        components: { UploadList },
        props: {
            value: {
                type: [String,Object, Array],
                default: ''
            },
            //是否base64位转码
            base64: {
                type: Boolean,
                default: false
            },
            //是否是导入，导入默认会有个提示
            isImport:{
                type: Boolean,
                default: false
            },
            //是否以base64 json自动上传
            upLoadWithJson:{
                type: Boolean,
                default: false
            },
            //不要自动上传
            notAutoUpload: {
                type: Boolean,
                default: false
            },
            action: {
                type: String,
                // required: true
            },
            sc:{
                type: String,
                // required: true
            },
            headers: {
                type: Object,
                default () {
                    return {};
                }
            },
            multiple: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object
            },
            name: {
                type: String,
                default: 'file'
            },
            fileName:{
                type: String,
                default: 'fileName'
            },
            withCredentials: {
                type: Boolean,
                default: false
            },
            showUploadList: {
                type: Boolean,
                default: true
            },
            //是否显示删除文件图标
            showRwmoveBtn: {
                type: Boolean,
                default: true
            },
            type: {
                type: String,
                validator (value) {
                    return oneOf(value, ['select', 'drag']);
                },
                default: 'select'
            },
            format: {
                type: Array,
                default () {
                    return [];
                }
            },
            accept: {
                type: String
            },
            maxSize: {
                type: [Number,String]
            },
            beforeUpload: Function,
            afterUpload:Function,
            onProgress: {
                type: Function,
                default () {
                    return {};
                }
            },
            onSuccess: {
                type: Function,
                default () {
                    return {};
                }
            },
            onError: {
                type: Function,
                default () {
                    return {};
                }
            },
            onRemove: {
                type: Function,
                default () {
                    return {};
                }
            },
            onPreview: {
                type: Function,
                default () {
                    return {};
                }
            },
            onExceededSize: {
                type: Function,
                default () {
                    return {};
                }
            },
            onFormatError: {
                type: Function,
                default () {
                    return {};
                }
            },
            defaultFileList: {
                type: Array,
                default() {
                    return [];
                }
            },
            paste: {
                type: Boolean,
                default: false
            },
            //超过限制图片张数 【true】能上传 【false】不能上传 需配合notAutoUpload或upLoadWithJson和base64使用
            isSurpassLimits: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                prefixCls: prefixCls,
                dragOver: false,
                fileList: [],
                files:[],
                basefiles:[],
                tempIndex: 1
            };
        },
        computed: {
            classes () {
                return [
                    `${prefixCls}`,
                    {
                        [`${prefixCls}-select`]: this.type === 'select',
                        [`${prefixCls}-drag`]: this.type === 'drag',
                        [`${prefixCls}-dragOver`]: this.type === 'drag' && this.dragOver
                    }
                ];
            },

        },
        methods: {
            handleClick () {
                this.$refs.input.click();
            },
            handleChange (e) {
                const files = e.target.files;

                if (!files) {
                    return;
                }
                this.uploadFiles(files);
                this.$refs.input.value = null;
            },
            onDrop (e) {
                this.dragOver = false;
                this.uploadFiles(e.dataTransfer.files);
            },
            handlePaste (e) {
                if (this.paste) {
                    this.uploadFiles(e.clipboardData.files);
                }
            },
            uploadFiles (files) {
                let postFiles = Array.prototype.slice.call(files);
                if (!this.multiple) {
                    postFiles = postFiles.slice(0, 1);
                }

                if (files.length === 0) return;
                //缓存上传的文件
                this.files=files
                for (let index = 0; index < files.length; index++) {
                    const file = files[index];
                    if(this.upload(file)===false){return false}
                    if(this.afterUpload)this.afterUpload(file)
                }
                if(this.base64){
                    this.readerFiles()
                }else{
                    this.$emit('input', postFiles)
                }
                //||this.upLoadWithJson
                if(this.notAutoUpload){
                    return false
                }

                //this.submit(postFiles)//调用提交服务
            },
            upload (file) {
                if (!this.beforeUpload) {
                    return this.post(file);
                }

                const before = this.beforeUpload(file);
                if (before && before.then) {
                    before.then(processedFile => {
                        if (Object.prototype.toString.call(processedFile) === '[object File]') {
                            this.post(processedFile);
                        } else {
                            this.post(file);
                        }
                    }, () => {
                        // this.$emit('cancel', file);
                    });
                } else if (before !== false) {
                    return this.post(file);
                } else {
                    // this.$emit('cancel', file);
                }
            },
            post (file) {
                let self=this
                // check format
                if (this.format.length) {
                    const _file_format = file.name.split('.').pop().toLocaleLowerCase();
                    const checked = this.format.some(item => item.toLocaleLowerCase() === _file_format);
                    if (!checked) {
                        this.$utils.tips.fileFormat(this.format)
                        this.onFormatError(file, this.fileList);
                        return false;
                    }
                }

                // check maxSize
                if (this.maxSize) {
                    if (file.size > this.maxSize * 1024) {
                        this.$utils.tips.exceededSize(this.maxSize)
                        this.onExceededSize(file, this.fileList);
                        return false;
                    }
                }
                this.handleStart(file);
            },
            submit(files){
                let self=this
                files=files||[]
                let params = new FormData()
                for (let index = 0; index < files.length; index++) {
                    const file = files[index];
                    params.append( self.fileName,file.name);
                    params.append( self.name,file,file.name);
                }

                for(let i in this.data){
                    params.append(i, this.data[i]);
                }
                this.$api.post({
                    sc:this.sc,
                    url:this.action, 
                    params:params,
                    notFilterNull:true,
                    headers:{'Content-Type':'multipart/form-data'},
                    onUploadProgress: e => {
                        for (let index = 0; index < files.length; index++) {
                            const file = files[index];
                            self.handleProgress(e,file)
                        }
                    },
                    success: r => {
                        for (let index = 0; index < files.length; index++) {
                            const file = files[index];
                            self.handleSuccess(r,file);
                            if(self.isImport)self.$utils.tips.gotoImportQuery(self)
                        }
                    },
                    failure:r=>{
                        for (let index = 0; index < files.length; index++) {
                            const file = files[index];
                            self.handleError(r, file);
                        }
                    }
                })
            },
            //文件转码
            readerFiles(){
                let pList=[],files=this.files,self=this
                for(let i=0;i<files.length;i++){
                    pList.push(
                        new Promise(function(resolve, reject) {
                            let filesObj={
                                fileName:files[i].name
                            }
                            //进行base64位转码
                            let reader = new FileReader()
                            reader.onloadend = function () {
                                filesObj.file=this.result
                                resolve(filesObj)
                            }
                            reader.readAsDataURL(files[i])
                        })
                    )
                }
                //全部转码完成后
                Promise.all(pList).then((files)=>{
                    self.basefiles=files
                    self.$emit('input', files)
                    if(self.upLoadWithJson){
                        let params={}
                        params[self.fileName] = files[0].fileName;
                        params[self.name] =files[0].file
                        if(self.isSurpassLimits && self.action && self.sc){
                            self.submitForJson(params,files)
                        } else {
                             this.onSuccess(files, null, files);
                        }
                    }
                })
            },
            submitForJson(params,files){
                let self=this
                self.$api.post({
                    sc:self.sc,
                    url:self.action, 
                    params:params,
                    notFilterNull:true,
                    headers:{'Content-Type':'application/json;charset=UTF-8'},
                    onUploadProgress: e => {
                         this.onProgress(e, null, files);
                    },
                    success: r => {
                        this.fileList = this.fileList.map(item => {
                            item.status = 'finished';
                            item.percentage = 100;
                            item.uid = Date.now() + this.tempIndex++;
                            return item;
                        });
                        this.onSuccess(r, null, files);
                    }
                })
            },
            handleStart (file) {
                file.uid = Date.now() + this.tempIndex++;
                const _file = {
                    status: 'uploading',
                    name: file.name,
                    size: file.size,
                    percentage: 0,
                    uid: file.uid
                };
                _file.showProgress=this.notAutoUpload?false:true

                if (!this.multiple){
                    this.fileList.unshift(_file);
                    this.fileList.splice(1, 1);
                }else{
                    this.fileList.push(_file);
                }
            },
            getFile (file) {
                let fileList = this.fileList;
                let target;
                fileList.every(item => {
                    target = file.uid === item.uid ? item : null;
                    return !target;
                });
                return target;
            },
            handleProgress (e, file) {
                let num = Math.round((e.loaded / e.total) * 100)
                const _file = this.getFile(file);
                this.onProgress(e, _file, this.fileList);
                _file.percentage = num || 0;
            },
            handleSuccess (res, file) {
                const _file = this.getFile(file);

                if (_file) {
                    _file.status = 'finished';
                    _file.response = res;

                    this.dispatch('FormItem', 'on-form-change', _file);
                    this.onSuccess(res, _file, this.fileList);

                    setTimeout(() => {
                        _file.showProgress = false;
                    }, 1000);
                }
            },
            handleError (err, file) {
                const _file = this.getFile(file);
                const fileList = this.fileList;

                _file.status = 'fail';

                //失败删除文件
                fileList.splice(fileList.indexOf(_file), 1);
                Dialog.alert({
                    message: err.message
                });
                this.onError(err,file);
            },
            handleRemove(file) {
                const fileList = this.fileList;
                fileList.splice(fileList.indexOf(file), 1);
                this.onRemove(file, fileList);
            },
            handlePreview(file) {
                if (file.status === 'finished') {
                    this.onPreview(file);
                }
            },
            clearFiles() {
                this.fileList = [];
            }
        },
        watch: {
            defaultFileList: {
                immediate: true,
                handler(fileList) {
                    this.fileList = fileList.map(item => {
                        item.status = 'finished';
                        item.percentage = 100;
                        item.uid = Date.now() + this.tempIndex++;
                        return item;
                    });
                }
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/common/file/ihlpUpload.vue